import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { alex } from "../characters/Alex";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { doDoorKnock, doPutMultipleImages, doTransition, doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V8AlexHomeAfter } from "./V8";

// MC arrives at Alex's house after Ann asked him to go there and help her out
// he can arrive either with the big ass Teddy bear or without
export const V8AlexHome = async (): Promise<any> => {
    // Alex opens the door
    if (Question.globalAnswers.V8AnnDateTargetsResults === "tryToHit") {
        doTransition(images.v8.V8AlexFrontDoor_0);
        doDoorKnock();
        ImageClass.setImage(images.v8.V8AlexFrontDoor_1);
        alex.talk(`${mc.name}? Is that you?`);
        mc.talk(`Were you expecting a different giant teddy bear?`);
        ImageClass.setImage(images.v8.V8AlexFrontDoor_3);
        alex.talk(`Haha! No. Come on in.`);
        doTransition(images.v8.V8AlexHome_26);
        mc.talk(`There we go.`);
        ImageClass.setImage(images.v8.V8AlexHome_27);
        alex.talk(`Wow... It's so huge.`);
        mc.talk(`Thank you, I hear that a lot.`);
        ImageClass.setImage(images.v8.V8AlexHome_28);
        alex.talk(`Haha!`);
        ImageClass.setImage(images.v8.V8AlexHome_29);
        alex.talk(`I meant the teddy! It's bigger than my Chucky!`);
        ImageClass.setImage(images.v8.V8AlexHome_31);
        alex.talk(`Ann said it's big but I didn't imagine it would be THAT big.`);
        mc.talk(`...`);
        ImageClass.setImage(images.v8.V8AlexHome_32);
        alex.talk(`Not a word!`);

    } else {
        doTransition(images.v8.V8AlexFrontDoor_2);
        doDoorKnock();
        ImageClass.setImage(images.v8.V8AlexFrontDoor_2);
        alex.talk(`${mc.name}! Thanks for coming.`);
        alex.talk(`I hope I didn't disturb you in the middle of something important.`);
        mc.talk(`Not at all.`);
        ImageClass.setImage(images.v8.V8AlexFrontDoor_4);
        alex.talk(`I'm glad! Come on in.`);


    }

    mc.talk(`Ok, so where is the patient?`);
    doWaitImageByTime(images.v8.V8AlexHome_4);
    alex.talk(`The same place I left it...`);
    ImageClass.setImage(images.v8.V8AlexHome_1.partials.V8AlexHome_2, { putParent: true });
    alex.talk(`I swear I didn't do anything! It just broke down again.`);
    // TODO: _3 with mouth close
    ImageClass.setImage(images.v8.V8AlexHome_1.partials.V8AlexHome_3);
    alex.talk(`Could it be a virus?`);
    mc.talk(`I deleted everything... I guess it's just a hardware problem.`);
    mc.talk(`Maybe it's time to buy a new laptop...`);
    alex.talk(`I guess so...`);
    mc.talk(`But let me try to fix it...`);
    // TODO: MC going to the laptop and Alex stops him Ann put the hands and stops the MC from going forward
    alex.talk(`Wait...`);
    // ImageClass.setImage(images.v8.V8AlexHome_3);
    alex.talk(`Can I tell you something?`);
    mc.talk(`Of course.`);
    // Both sitting on the bed
    alex.talk(`Let's sit down.`);
    doWaitImageByTime(images.v8.V8AlexHome_10.partials.V8AlexHome_15, { putParent: true });
    // alex.talk(`Alright... So...`);
    alex.talk(`You know... I'm glad that my laptop broke down again...`);
    alex.talk(`It gave me the perfect excuse to talk to you.`);
    ImageClass.setImage(images.v8.V8AlexHome_10.partials.V8AlexHome_16);
    alex.talk(`The last time you were here with Ann you mentioned the photos I have around here...`);
    ImageClass.setImage(images.v8.V8AlexHome_10);
    mc.talk(`Did I say something that offended you?`);
    ImageClass.setImage(images.v8.V8AlexHome_10.partials.V8AlexHome_15, { putParent: true });
    alex.talk(`Oh, no. Not at all, I just wanted to share something with you.`);
    alex.talk(`I didn't say anything the other day because I didn't want to ruin the mood.`);
    alex.talk(`But now I can explain some things.`);
    ImageClass.setImage(images.v8.V8AlexHome_10.partials.V8AlexHome_14);
    mc.talk(`I'm listening.`);
    ImageClass.setImage(images.v8.V8AlexHome_10.partials.V8AlexHome_15);
    alex.talk(`So I know what it might have looked like when you entered my room.`);
    ImageClass.setImage(images.v8.V8AlexHome_10.partials.V8AlexHome_16);
    alex.talk(`You must have thought to yourself: "Damn that girl is a complete narcissist".`);
    alex.talk(`Like who would have this many pictures of themselves set out?`);
    ImageClass.setImage(images.v8.V8AlexHome_10.partials.V8AlexHome_17);
    alex.talk(`But it's the complete opposite...`);
    alex.talk(`You see... When I was little, I didn't really like how I looked and was very self-conscious.`);
    alex.talk(`People have basically told me I'm pretty since the day I was born.`);
    ImageClass.setImage(images.v8.V8AlexHome_10.partials.V8AlexHome_16, { putParent: true });
    alex.talk(`But no matter what, I just didn't like myself.`);
    alex.talk(`I know it sounds stupid... But that's just how I felt and I couldn't control it.`);
    ImageClass.setImage(images.v8.V8AlexHome_10.partials.V8AlexHome_15, { putParent: true });
    alex.talk(`I kept looking away when there were mirrors around just so I could avoid looking at myself.`);
    // doPutMultipleImages([images.v8.V8AlexHome_10, images.v8.V8AlexHome_10.partials.V8AlexHome_14]);

    ImageClass.setImage(images.v8.V8AlexHome_10.partials.V8AlexHome_14, { putParent: true });
    await mc.talk(`That sounds a bit extreme.`);
    ImageClass.setImage(images.v8.V8AlexHome_10.partials.V8AlexHome_15);
    alex.talk(`Yeah...`);
    alex.talk(`But I knew I had to deal with that feeling...`);
    doWaitImageByTime(images.v8.V8AlexHome_18);
    alex.talk(`I decided that in order to love myself I couldn't keep avoiding myself.`);
    alex.talk(`That's the real reason why I have so many pictures of myself around.`);
    alex.talk(`And that's why I took my Insta to the extreme...`);
    ImageClass.setImage(images.v8.V8AlexHome_19);
    alex.talk(`I know some of the pictures I post there are making me look like a slut... But I got addicted to the attention.`);
    alex.talk(`If I stop hearing my phone's notifications, I just post another image...`);
    alex.talk(`I hope it doesn't make me seem like a shallow person.`);
    alex.talk(`And it seems the cure to one affliction has created another. Haha!`);
    ImageClass.setImage(images.v8.V8AlexHome_21);
    mc.talk(`It sounds like you aren't fully happy with what you do.`);
    ImageClass.setImage(images.v8.V8AlexHome_20);
    alex.talk(`Well... I know I'm very fortunate.`);
    alex.talk(`I know that many people would like to be in my place.`);
    alex.talk(`Like what I do? I just upload some teasing photos to Insta and I get paid for it...`);
    // TODO: do talking render for 21
    ImageClass.setImage(images.v8.V8AlexHome_21);
    mc.talk(`I guess it's true about what people say. That Insta is totally fake.`);
    alex.talk(`Yeah...`);
    ImageClass.setImage(images.v8.V8AlexHome_20);
    alex.talk(`But it's not like I'm suffering! I do enjoy what I do. But maybe because it was so easy for me, it's became boring...`);

    alex.talk(`Anyway... This is me...`);
    doWaitImageByTime(images.v8.V8AlexHome_10.partials.V8AlexHome_15, { putParent: true });
    alex.talk(`That totally sounded better in my head...`);

    ImageClass.setImage(images.v8.V8AlexHome_10);
    mc.talk(`Were you practicing it?`);
    ImageClass.setImage(images.v8.V8AlexHome_10.partials.V8AlexHome_15);
    alex.talk(`A bit...`);
    ImageClass.setImage(images.v8.V8AlexHome_10);
    mc.talk(`I mean... We barely know each other. Why do you care what I think?`);
    ImageClass.setImage(images.v8.V8AlexHome_10.partials.V8AlexHome_16);
    alex.talk(`My main group of friends I speak to... They all have know me since I was young and understand what I have gone through.`);
    alex.talk(`The rest are just creeps from Insta, who will basically agree with everything I say.`);
    ImageClass.setImage(images.v8.V8AlexHome_10.partials.V8AlexHome_15, { putParent: true });
    alex.talk(`You just met me and I kept thinking how I must look to someone who doesn't really know me.`);
    if (mc.properties.annStatus === "gf") {
        alex.talk(`And the fact that you are my best friend's boyfriend is a part of it too.`);
    } else {

    }
    alex.talk(`I tell people I don't care, when they ask me what I think about people's opinions of me given the images I post.`);
    alex.talk(`Maybe it's true at that moment... But later on it bothers me a bit.`);
    ImageClass.setImage(images.v8.V8AlexHome_10);
    mc.talk(`You can quit you know.`);
    ImageClass.setImage(images.v8.V8AlexHome_10.partials.V8AlexHome_15);
    alex.talk(`I can't. I'm too far in. It's basically my job. And I love parts of it.`);
    alex.talk(`I love getting recognized on the street and the money it brings in. I don't want to throw that away.`);
    alex.talk(`I guess everything comes with a price right?`);
    ImageClass.setImage(images.v8.V8AlexHome_10);
    mc.talk(`Right. And I think it's up to you to decide what you want to do moving forward.`);
    // TODO: like 10 -> smiling > mouth open
    alex.talk(`True! Thank you for letting me get this off my chest!`);

    ImageClass.setImage(images.v8.V8AlexHome_13);
    await alex.setQuestion(new Question({ text: `Wow, I totally bummed the mood! Let's change the subject!`, options: { think: false }, key: `V8AlexHomeComplimentedOnDress` })
        .option({ title: `Compliment her`, key: true })
        .option({ title: `Let her change the subject`, key: false }));


    if (Question.globalAnswers.V8AlexHomeComplimentedOnDress) {
        await mc.set((properties) => {
            properties.alexRelationship++;
        });
        mc.talk(`Well, I didn't say it when I was coming in, but you look really good in that outfit.`);
        // TODO: like 10 -> smiling > mouth open
        alex.talk(`Thank you!`);
        alex.talk(`To be honest, I was just trying it out to see if it fits.`);
        alex.talk(`I was about to get into the shower and take it for a spin! Haha.`);
    }

    ImageClass.setImage(images.v8.V8AlexHome_10);
    mc.talk(`By the way, what about the laptop, do you still want me to try and fix it?`);
    ImageClass.setImage(images.v8.V8AlexHome_10.partials.V8AlexHome_15);
    alex.talk(`After my monologue, I guess I'd rather leave it broken for now... It will be good therapy for me.`);
    // TODO: like 10 -> smiling > mouth open
    alex.talk(`I mean I still have my phone, haha.`);
    ImageClass.setImage(images.v8.V8AlexHome_10);
    mc.talk(`Sleep on it and let me know. I'm basically across the street.`);
    alex.talk(`Thank you!`);
    // near the door
    doWaitImageByTime(images.v8.V8AlexHome_23);
    alex.talk(`And sorry that I dragged you here for nothing.`);
    ImageClass.setImage(images.v8.V8AlexHome_24);
    await mc.setQuestion(new Question({ text: `I'm glad you were able to get some things off your chest.`, options: { think: false }, key: `V8AlexRoomHuggedHer` })
        .option({ title: `Hug her`, key: true })
        .option({ title: `Reach for the door knob`, key: false }));


    if (Question.globalAnswers.V8AlexRoomHuggedHer) {
        doWaitImageByTime(images.v8.V8AlexHome_25, { wait: true });

        // TODO: hug

    } else {
        // TODO: hand of the MC on the door knob
        // doWaitImageByTime(images.v8.V8AlexHome_25, undefined, { wait: true });

    }

    // TODO: if teddy, standing outside her house and can sneak inside and hide inside the teddy






    return jump(V8AlexHomeAfter, "V8AlexHomeAfter");
};


export const V8AlexHomeTeddy = async (): Promise<any> => {
    // ImageClass.setImage(images.TODO_IMAGE)

    // return jump(TODO_JUMP, "TODO_JUMP");
};
